import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const loadGoogleMapsScript = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    return;
  }

  const existingScript = document.querySelector(
    `script[src^="https://maps.googleapis.com/maps/api/js"]`
  );
  if (existingScript) return;

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

loadGoogleMapsScript();

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
